/**
 * Home / landing — countries bottom sheet & compact map behavior.
 *
 * Breakpoints align with product spec: compact = width ≤ 1024px, desktop = ≥ 1025px.
 * Set STRICT_MODE to false to restore dismissible sheet, map taps, and peek animation.
 */
export const HOME_COMPACT_MAX_WIDTH_PX = 1024;
export const HOME_DESKTOP_MIN_WIDTH_PX = HOME_COMPACT_MAX_WIDTH_PX + 1;

/** When false: bottom sheet can be closed via X / backdrop / Escape; map stays interactive on compact. */
export const HOME_COUNTRIES_SHEET_STRICT_MODE = true;

export function mediaCompactHome() {
  return `(max-width: ${HOME_COMPACT_MAX_WIDTH_PX}px)`;
}

export function mediaDesktopHome() {
  return `(min-width: ${HOME_DESKTOP_MIN_WIDTH_PX}px)`;
}
